import { useMutation, useQuery } from '@apollo/client';
import React, { useState } from 'react';
import styled from 'styled-components';

import Column from '../../ui/Column';
import Button from '../../ui/form/Button';
import ButtonGroup from '../../ui/form/ButtonGroup';
import Input from '../../ui/form/Input';
import NumberSpinner from '../../ui/form/NumberSpinner';
import Row from '../../ui/Row';
import Table from '../../ui/Table';
import { ENGINES_BY_USER, UPDATE_USER } from '../../../api/GraphQL';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router';
import CreateEngine from '../CreateEngine';

const Main = styled.div`
  display: flex;
  background-color: #fff;
  width: 100%;
  height: 100%;
  margin-left: -15px;
  padding: 15px;
  flex-direction: column;
`;

export default function Engines({ user }) {
  const { loading, data } = useQuery(ENGINES_BY_USER, {
    variables: { id: user._id },
  });
  const [newEngine, setNewEngine] = useState(user);

  const history = useHistory();
  const match = useRouteMatch();

  return (
    <Main>
      <Button
        label="New Engine +"
        onClick={() => {
          history.push(match.url + '/create');
        }}
      />
      <Switch>
        <Route path={`${match.path}/create`}>
          <CreateEngine user={user} />
        </Route>
        <Route path={`${match.path}/`}>
          {data?.enginesByUserId && (
            <Table
              data={data?.enginesByUserId}
              columns={[
                { Header: 'Name', accessor: 'name' },
                {
                  Header: 'Key',
                  accessor: 'key',
                },
              ]}
            />
          )}
        </Route>
      </Switch>
    </Main>
  );
}
